var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmountedEss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82996 6.78997L9.20996 12.17L7.49996 13.89C7.1465 14.2426 6.72699 14.5222 6.26542 14.7127C5.80386 14.9031 5.30928 15.0008 4.80996 15C4.06504 14.9986 3.33616 14.7834 2.70996 14.38L1.53996 15.58L0.459961 14.52L1.64996 13.32C1.15794 12.5871 0.934908 11.7065 1.01877 10.8278C1.10263 9.94908 1.48821 9.12653 2.10996 8.49997L3.82996 6.78997ZM14.48 0.469971L15.54 1.52997L14.27 2.77997C14.7914 3.54924 15.0286 4.47605 14.9411 5.40123C14.8535 6.32641 14.4465 7.19222 13.79 7.84997L12.63 8.99997L11.31 7.69997L9.48996 9.52997L8.42996 8.46997L10.2 6.63997L9.29996 5.74997L7.46996 7.54997L6.46996 6.47997L8.28996 4.67997L6.99996 3.36997L8.12996 2.21997C8.78894 1.565 9.65538 1.15985 10.5805 1.07409C11.5057 0.988328 12.4318 1.2273 13.2 1.74997L14.48 0.469971Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmountedEss);
export default __webpack_public_path__ + "static/media/unmounted_ess.223e2e1dc02466109b2c6509a5bbdba4.svg";
export { ForwardRef as ReactComponent };